__turbopack_context__.v({
  "chaptersOverlay": "_6AQLVa_chaptersOverlay",
  "fill": "_6AQLVa_fill",
  "hoverFill": "_6AQLVa_hoverFill",
  "segment": "_6AQLVa_segment",
});
